

export const selectTargetValue = (monitoring_arr = []) => {
    let result = monitoring_arr.filter(el => el.type === 'target');
    return result.length > 0 ? result[0] : null;
  };